export const tagSizeConfig = {
  sm: {
    sizeStyles: "h-5 min-w-5 xxs-mono-semibold rounded-md gap-1 px-1.5",
  },
  default: {
    sizeStyles: "h-6 min-w-6 tiny-mono-semibold rounded-lg gap-2 px-2",
  },
  lg: {
    sizeStyles: "h-[30px] min-w-[30px] sm-mono-semibold rounded-lg gap-2 px-2",
  },
};

export const tagThemeConfig = {
  NO: {
    themeStyles:
      "bg-chart-red-faint text-fg-base from-red-base/25 to-red-base/0",
  },
  POSSIBLY: {
    themeStyles:
      "bg-chart-yellow-faint text-fg-base from-yellow-base/25 to-yellow-base/0",
  },
  YES: {
    themeStyles:
      "bg-chart-green-faint text-fg-base from-green-base/25 to-green-base/0",
  },
  MIXED: {
    themeStyles:
      "bg-chart-orange-faint text-fg-base from-orange-base/25 to-orange-base/0",
  },
  UNKNOWN: {
    themeStyles: "bg-bg-faint text-fg-base from-subtle to-subtle/0",
  },
  DEFAULT: {
    themeStyles: "bg-bg-faint text-fg-muted",
  },
  SELECTED: {
    themeStyles: "bg-accent-bg-muted text-accent-emphasis",
  },
};

export const meterTagIconConfig = {
  NO: "icon-x",
  POSSIBLY: "icon-minus",
  YES: "icon-check",
  MIXED: "icon-asterisk",
  UNKNOWN: "icon-dashed-line",
};
